<template>
  <NavBurgerMenuUniverse :id="item.id" :image="item.image" :title="item.title">
    <NavBurgerMenuHeader
      :color="item.color"
      :title="item.title"
      @back="clearActiveMenu"
      @close="$emit('click-item')"
    />
    <section class="overflow-auto pb-32">
      <NavServiceList
        v-for="service in item.details"
        :key="service.name"
        :service
      />
      <div class="flex flex-col gap-12">
        <NavCategoryHeader
          class="mx-24"
          :see-all-url="item.url"
          @click-see-all="$emit('click-item')"
        />
        <ul
          class="grid grid-cols-1 gap-x-16 gap-y-32 px-24 sm:grid-cols-2 md:grid-cols-3"
        >
          <li v-for="child in item.children" :key="child.id">
            <NavBurgerMenuCategory
              :image="child.image"
              :title="child.title"
              :url="child.url"
              @click="$emit('click-item')"
            />
          </li>
        </ul>
      </div>
    </section>
  </NavBurgerMenuUniverse>
</template>

<script setup lang="ts">
import { useActiveMenu } from '../../composables/useActiveMenu'
import type { NavigationItem } from '../../types'
import NavCategoryHeader from '../shared/NavCategoryHeader.vue'

import NavBurgerMenuCategory from './NavBurgerMenuCategory.vue'
import NavBurgerMenuHeader from './NavBurgerMenuHeader.vue'
import NavBurgerMenuUniverse from './NavBurgerMenuUniverse.vue'
import NavServiceList from './NavServiceList.vue'

defineProps<{
  item: NavigationItem
}>()

defineEmits<{
  'click-item': []
}>()

const { clearActiveMenu } = useActiveMenu()
</script>
